module.exports = __webpack_public_path__ + "static/media/instagram-f.a9fbe438.svg";